module.exports = "data:text/x-markdown;base64,VGhpcyBsZXZlbCBpcyB0aGUgd2VsbCBrbm93biBnYW1lIDogUGFwZXItU2Npc3NvcnMtU3RvbmUuCgpZb3UgaGF2ZSB0byB3aW4gdGhyZWUgdGltZXMgY29udGludW91c2x5LgoKYGBgCkluIHRoaXMgZ2FtZSA6IAowIHN0YW5kcyBmb3IgU2Npc3NvcnMKMSBzdGFuZHMgZm9yIFN0b25lCjIgc3RhbmRzIGZvciBQYXBlcgpgYGAKClRoaW5ncyB0aGF0IG1pZ2h0IGhlbHA6CiogVXNlIG5vdCBvbmx5IHRoZSBjb25zb2xlIHRvIHBsYXkgdGhlIGdhbWUuCiogUmFuZG9tIG51bWJlcnMgaW4gc29saWRpdHkgY291bGQgYmUgdHJpY2t5Lgo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/paperScissorsStone.md
// module id = 1395
// module chunks = 0